import React, { Component } from 'react'
import Transition from 'react-transition-group/Transition'
import { Alert } from 'react-bootstrap'


export default class Notice extends Component {
  constructor(props) {
    super(props)
    this.state = {
      show: false
    }
  }

  componentDidMount() {
    // this.setState({
    //   show: !this.state.show
    // })

    // this.runTimeOut = setTimeout(() => {
    //   this.setState({
    //     show: !this.state.show
    //   })
    // }, this.timeOut)
  }

  componentWillUnmount() {
    clearTimeout(this.runTimeOut)
  }

  render() {
    const duration = 200
    const defaultStyle = {
      padding: '20px',
      color: 'white',
      backgroundColor: 'ForestGreen',
      borderRadius: '5px',
      left: '50%',
      transform: 'translateX(-50px)',
      position: 'fixed',
      zIndex: '100'
    }
    const transitionStyles = {
      entering: {
        top: '-50px',
        opacity: 0
        // transform: 'translate3d(0, -100 %, 0)'
      },
      entered: {
        top: '50px',
        opacity: 1,
        zIndex: -5,
        transition: 'top 500ms, opacity 1500ms, z-index 1500ms'
      },
      exiting: {
        top: '-50px',
        opacity: 0
        // transition: 'top 1s, opacity 1.5s'
      },
      exited: {
        top: '50px',
        opacity: 1,
        zIndex: -5,
        transition: 'top 500ms, opacity 1500ms, z-index 1500ms'
      }
    }
    return (
      <Transition in={this.props.show} timeout={duration}>
        {
          (state) => (
            <div
              style={{
                ...defaultStyle,
                ...transitionStyles[state]
              }}
            >
              <strong>บันทึกข้อมูลเรียบร้อย</strong>
            </div>
          )
        }
      </Transition>
    )
  }
}


// WEBPACK FOOTER //
// ./src/view/report/Notice.js